import Vue from 'vue'
import Vuex from 'vuex'
import authModule from './auth'
import menuModule from './menu'
import uiModule from './ui'
import { routeAccess } from '@/utils/routeAccess'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    route: null,
  },
  getters: {
    /**
     * **라우터 가드가 판정에 넘기는 세션**(`utils/routeAccess` 의 `session`) — 가드(`router`)와 보류 판정(`App.vue`)이 같은 값을
     * 읽는다. `menu` 는 지금 계정으로 읽은 메뉴이거나 「아직 모른다·못 읽었다」다(`menu/sessionMenu`).
     */
    routeSession(state, getters) {
      const isLogin = getters['auth/isLogin']

      return {
        auth: getters['auth/auth'],
        authId: isLogin ? getters['auth/authId'] : null,
        menu: getters['menu/sessionMenu'],
      }
    },
    /**
     * **확정된 라우트(`state.route`)에 대한 지금의 답** — 메뉴를 기다리는 화면이면 `needsMenu`. `App.vue` 는 이 답으로 화면 본문을
     * 보류하고, `router` 는 이 답이 거절로 풀리면 안내로 바꿔 끼운다. 한 값을 두 경계가 읽는다(따로 계산하지 않는다).
     */
    currentRouteAccess(state, getters) {
      return routeAccess(state.route, getters.routeSession)
    },
  },
  mutations: {
    SET_ROUTE(state, payload) {
      state.route = payload
    },
  },
  modules: {
    auth: authModule,
    menu: menuModule,
    ui: uiModule,
  },
})

export default store
